export const selectSubmissionReviewsSlice = state => state?.submissionReviews

export const selectSubmissionReviewByVersion = (state, submissionVersion) => {
  const reviews = state?.submissionReviews?.submissionReviews?.results
  if (!reviews) {
    return undefined
  }

  let targetReview
  for (const review in reviews) {
    if (reviews[review].submission_version === submissionVersion) {
      targetReview = reviews[review]
    }
  }
  return targetReview
}

export const selectSubmissionReviewResultsByVersion = (state, submissionVersion) => {
  const reviews = state?.submissionReviews?.submissionReviews?.results
  if (!reviews) {
    return undefined
  }

  let targetReview
  for (const review in reviews) {
    if (reviews[review].submission_version === submissionVersion) {
      targetReview = reviews[review]
    }
  }

  return state.submissionReviews.reviewResults?.[targetReview?._id]
}

export const selectRepurchaseWarrantySubmissionByVersion = (state, submissionVersion) => {
  const repurchaseWarrantyReviews = state?.submissionReviews?.repurchaseWarrantyReviews
  const reviewId = repurchaseWarrantyReviews?.reviewIdBySubmissionVersion?.[submissionVersion]
  const targetReview = repurchaseWarrantyReviews?.results?.[reviewId]

  return targetReview
}

export const selectRepurchaseWarrantyReviewResultsByVersion = (state, submissionVersion) => {
  const repurchaseWarrantyReviews = state?.submissionReviews?.repurchaseWarrantyReviews
  const reviewId = repurchaseWarrantyReviews?.reviewIdBySubmissionVersion?.[submissionVersion]
  const targetReview = repurchaseWarrantyReviews?.results?.[reviewId]

  return state.submissionReviews.repurchaseWarrantyReviewsResults?.[targetReview?._id]
}

/**
 * Selector to check if all repurchase warranty review results are either ACCEPTED or have comments
 * @param {Object} state - The current state
 * @param {string} submissionVersion - The submission version
 * @returns {boolean} True if all results are either ACCEPTED or have comments, false otherwise
 */
export const areAllRepurchaseWarrantyResultsAcceptedOrCommented = (state, submissionVersion) => {
  const results = selectRepurchaseWarrantyReviewResultsByVersion(state, submissionVersion)

  if (!results) {
    // All results passed.
    return true
  }

  return Object.values(results).every(result =>
    result.outcome === 'ACCEPTED' || (result.note_logs?.length > 0)
  )
}

export const selectReviewNotesSlice = state => state?.submissionReviews?.reviewNotes

export const selectReviewNotesByKey = (state, orderId, submissionVersion) => {
  return selectReviewNotesSlice(state)?.[`${orderId}-${submissionVersion}`]
}

export const selectReviewNotesByVersion = (state, orderId, submissionVersion) => {
  return selectReviewNotesByKey(state, orderId, submissionVersion)
}

export const selectReviewNotesShownByVersion = (state, orderId, submissionVersion) => {
  return selectReviewNotesByKey(state, orderId, submissionVersion)?.showNotes
}

export const selectGlobalFields = state => state?.submissionReviews?.globalFields

export const selectRulesetsSlice = state => state?.submissionReviews?.rulesets

export const selectRulesets = state => { return selectRulesetsSlice(state)?.rulesets }
